/* @flow */

import React from 'react';
import Helmet from 'react-helmet';

// import { injectIntl } from 'react-intl';
import type { QueryProps } from 'react-apollo';

import Navbar from '@uniiverse/library/components/navbar';
import Footer from '@uniiverse/library/components/footer';

import LoadingPage from '../../../components/loading-page/index';
import ProfileInfo from '../../../components/profile/profile-info/index';
import CoverPhoto from '../../../components/profile/cover-photo/index';
import Events from '../../../components/profile/events/index';
import Flash from '../../../components/flash';
import DigitalData from '../../../components/digital-data';

import { localeMap } from '../../../lib/locale-loader';
import { isPrivate } from '../../../modules/profile/getters';

import style from './index-module.css';

type Props = {
  data: ProfileQuery & QueryProps,
  currentUser: Object,
  switchLocale: Function,
  randomColor: string,
  showFlashMessage: boolean,
  dismissFlashMessage: Function,
  intl: IntlShape
};

const RANDOM_COLORS = ['#B2443E', '#FF8864', '#007162', '#00C7AF', '#B17C00', '#FDC04C'];

export const generateRandomColor: Function = (profileId: string): string => {
  const seed = parseInt(profileId.replace(/\D/g, ''), 10);
  return RANDOM_COLORS[seed % RANDOM_COLORS.length];
};

const Loaded: Function = (props: Props): React$Element<*> => {
  const { data: { profile }, currentUser, switchLocale, showFlashMessage, dismissFlashMessage } = props;
  const userOwnsProfile = currentUser && currentUser.id === profile.id;

  return <div>
    <Navbar user={currentUser} />

    {
      (userOwnsProfile && isPrivate(profile) && showFlashMessage) ?
        <Flash
          dismissMessage={dismissFlashMessage}
          messages={[{ id: 0, content: props.intl.messages['profile.viewing-own-private-profile'], level: 'info' }]}
        /> :
        null
    }

    <div className={style.container}>
      <div className={style.content}>
        <DigitalData user={profile} />
        <Helmet title={`${profile.name || ''} - Universe`} />
        <CoverPhoto {...props} />

        <div className={style.profileContent}>
          <div className={style.profileInfoContent}>
            <ProfileInfo {...props} />
          </div>
          <div className={style.profileMainContent}>
            <Events {...props} />
          </div>
        </div>
      </div>
    </div>
    <Footer switchLocale={switchLocale} locales={localeMap} />
  </div>;
};

const Layout: Function = (props: Props): React$Element<*> => {
  if (props.data.loading || props.data.error) {
    return <LoadingPage />;
  }

  const { data: { profile }} = props;

  if (!window.location.pathname.endsWith(`-${profile.slug || ''}`)) {
    window.location.href = profile.url; // replace the URL (id) with the SEO friendly one (slug)
    return <LoadingPage />;
  }

  const randomColor = generateRandomColor(profile.id);
  const propsWithRandomColor = { randomColor, ...props };
  return <Loaded {...propsWithRandomColor} />;
};

export default Layout;



// WEBPACK FOOTER //
// ./src/routes/profile/layouts/index.js